<script setup lang="ts"></script>

<template>
  <header
    :class="$style.stepNewAirRoadHeader"
    data-testid="stepNewAirRoadHeader"
  >
    <div>
      <slot></slot>
    </div>
    <div v-if="$slots.right">
      <slot name="right"></slot>
    </div>
  </header>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.stepNewAirRoadHeader {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.83em; /* `:any(article, aside, nav, section) h1` default margin */

  :global {
    h1 {
      margin: 0;
    }
    h3 {
      margin: 0;
    }
  }
}
</style>
